/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { memo } from "react";
import PropTypes from "prop-types";
import FilterPills from "../../filter-pills/component";
import { NUMBER } from "../../../../constants/app-constants";
import styles from "../styles.css";

const FilterPillsSection = ({
    selectedFilterPills,
    selectedFiltersModified,
    getSelectedFilterTag,
    onRemoveFilter,
    handleShowAllSelectedFilter,
    showAllSelectedFilter,
    getOrCreateRef,
    saleLive,
    FILTER_ENTITIES,
    clearAllFilters
}) => {
    return (
        <div className="col-12" styleName={"styles.selectedFilterWrap"}>
            <p styleName={"styles.selectedFilter"}>Selected Filters</p>
            <div styleName={"styles.filterWrapper"}>
                <p id="clearAllFilters" styleName={"styles.clearFilter"} onClick={clearAllFilters}>
                    Clear all filters
                </p>
                {selectedFilterPills.map((item, index) =>
                    item ? (
                        <div
                            ref={getOrCreateRef(`remove-filter-${item?.filterKey}`)}
                            styleName={"styles.filterPillsWrapper"}
                            key={index}
                        >
                            <FilterPills
                                filterName={getSelectedFilterTag(item)}
                                onRemoveFilter={() => onRemoveFilter(item)}
                                defaultText={item?.filterKey === FILTER_ENTITIES.PROMOTION && saleLive ? true : false}
                            />
                        </div>
                    ) : null
                )}
                {selectedFiltersModified.length > NUMBER.SIX && (
                    <div styleName={"styles.filterPillsWrapper"} onClick={handleShowAllSelectedFilter}>
                        <FilterPills
                            filterName={showAllSelectedFilter ? "Show less" : `show ${selectedFiltersModified.length - NUMBER.SIX} more`}
                            showCloseIcon={false}
                            type={"white"}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

FilterPillsSection.propTypes = {
    selectedFilterPills: PropTypes.array.isRequired,
    selectedFiltersModified: PropTypes.array.isRequired,
    getSelectedFilterTag: PropTypes.func.isRequired,
    onRemoveFilter: PropTypes.func.isRequired,
    handleShowAllSelectedFilter: PropTypes.func.isRequired,
    showAllSelectedFilter: PropTypes.bool.isRequired,
    getOrCreateRef: PropTypes.func.isRequired,
    saleLive: PropTypes.bool,
    FILTER_ENTITIES: PropTypes.object.isRequired,
    clearAllFilters: PropTypes.func.isRequired
};

export default memo(FilterPillsSection);
